import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router';
import { AppProvider, useApp } from './lib/app';
import { configured } from './lib/supabase';
import { Shell } from './ui/Shell';
import { PresenceProvider } from './lib/presence';
import { ToastHost } from './ui/kit';
import { ViewerHost } from './ui/Viewer';
import Login from './routes/Login';
import SetPassword from './routes/SetPassword';
import Home from './routes/Home';
import Buildings from './routes/Buildings';
import BuildingPage from './routes/BuildingPage';
import Contracts from './routes/Contracts';
import Orgs from './routes/Orgs';
import Files from './routes/Files';
import Admin from './routes/admin/Admin';
import Register from './routes/Register';
import ItemPage from './routes/ItemPage';
import Search from './routes/Search';

function Splash() {
  return (
    <div className="auth">
      <div className="logo" style={{ width: 56, height: 56, fontSize: 18 }} aria-label="Loading">
        C3
      </div>
    </div>
  );
}

function Gate() {
  const { ready, session } = useApp();
  const loc = useLocation();
  if (!ready) return <Splash />;
  if (loc.pathname === '/set-password') return <SetPassword />;
  if (!session || !configured) return <Login welcome={loc.pathname === '/welcome'} />;
  return (
    <PresenceProvider>
    <Shell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/buildings" element={<Buildings />} />
        <Route path="/buildings/:id" element={<BuildingPage />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/orgs" element={<Orgs />} />
        <Route path="/files" element={<Files />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/r/:module" element={<Register />} />
        <Route path="/r/:module/:id" element={<ItemPage />} />
        <Route path="/search" element={<Search />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
    </PresenceProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <ToastHost>
          <ViewerHost>
            <Gate />
          </ViewerHost>
        </ToastHost>
      </AppProvider>
    </BrowserRouter>
  );
}
